import React, { useRef, useState } from "react";

import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import ContactForm from "../../ContactForm";

export default function TitleForm() {
  const navigate = useNavigate();
  const [formDataState, setFormDataState] = useState({
    name: "",
    email: "",
    phone: "",
    findUs: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    setIsSubmit(true);
    e.preventDefault();

    // Prepare FormData object
    const formData = new FormData();
    formData.append("name", formDataState.name);
    formData.append("email", formDataState.email);
    formData.append("phone", formDataState.phone);
    formData.append("findUs", formDataState.findUs);
    formData.append("message", formDataState.message);
    formData.append("date", formDataState.date);

    try {
      const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
      if (response.data.success) {
        setStatus("Message sent successfully!");
        // Reset form state
        setFormDataState({
          name: "",
          email: "",
          phone: "",
          findUs: "",
          message: "",
        });

        navigate("/thank-you");
      } else {
        setStatus("Failed to send message.");
        console.error(response.data.error);
      }
      setIsSubmit(false);
    } catch (error) {
      setStatus("Something went wrong!");
      console.error("Axios error:", error);
    }
  };


  return (
    <div>
      <section className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 px-xl-8 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <span className="pq-section-sub-title">
                  Medfirst ENT Centre
                </span>
                <h1 className="pq-section-title">Best Tonsillectomy Surgery in Delhi, India </h1>
                <p className="pq-section-description">
                  Tonsillectomy is a surgical procedure involving the complete removal of the palatine tonsils, which are two oval-shaped lymphoid tissues located at the back of the throat, on either side of the oropharynx. These tonsils are part of the immune system and help in defending the body against infections, particularly in early childhood.
                  However, in some individuals, the tonsils can become a source of recurrent infections (recurrent tonsillitis) or may enlarge significantly (tonsillar hypertrophy), leading to difficulty in breathing, swallowing, snoring, and sleep disturbances such as <Link to="https://entdelhi.com/tonsils/">obstructive sleep apnoea</Link>
                  .{" "}
                </p>
              </div>
            </div>
            <div className="col-xl-4 pe-xl-4">
                <ContactForm />
              {/*<div className="pq-bg-white pq-form-bg-white p-4">
                <div className="pq-applyform-whitebg p-4">
                  <form onSubmit={sendEmail}>
                    <div className="row">
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={formDataState.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formDataState.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone Number"
                          value={formDataState.phone}
                          onChange={handleChange}
                          required
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          name="message"
                          Placeholder="Concern"
                          value={formDataState.message}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <select
                          name="findUs"
                          value={formDataState.findUs}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>
                            How did you find us?
                          </option>
                          <option value="youtube">YouTube</option>
                          <option value="instagram-facebook">
                            Instagram/Facebook
                          </option>
                          <option value="google">Google</option>
                          <option value="reference">Reference</option>
                        </select>
                      </div>
                      <div className="col-md-12 pt-2">
                        {!isSubmit && <button type="submit">Book Now</button>}
                        {isSubmit && <button type="submit" disabled={true}>Booking
                          <div class="ms-4 spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                          </div></button>}                      </div>
                    </div>
                  </form>
                  <p>{status}</p>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
